import { render, staticRenderFns } from "./SubmissionFormStage.vue?vue&type=template&id=2b60af67&scoped=true&"
import script from "./SubmissionFormStage.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormStage.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormStage.vue?vue&type=style&index=0&id=2b60af67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60af67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
